export const SEPARATOR = ', ';
export const MAX_DISPLAY_POINTS = 2;
export const HAS_MORE_TEXT = ', ...';
